// src/composables/usePocketPasswordReset.js

import usePocketbase from '@/composables/usePocketbase'
import { useToast } from './useToast'

export function usePasswordReset() {
  const pb = usePocketbase()
  const { showToast } = useToast()

  async function sendPasswordReset(email) {
    try {
      await pb.collection('users').requestPasswordReset(email)
      showToast('Password reset link sent')
    } catch (e) {
      console.error(e)
      showToast(`Failed to send reset link: ${e.message}`)
    }
  }

  return {
    sendPasswordReset,
  }
}
